/**
 * Formata uma data UTC para o timezone de São Paulo (GMT-3)
 * @param {string} dataString - Data em formato ISO (UTC)
 * @param {boolean} incluirHora - Se deve incluir hora e minuto
 * @returns {string} Data formatada em pt-BR
 */
export const formatarDataUtc = (dataString, incluirHora = true) => {
  if (!dataString) return "-";
  
  // Adiciona "Z" para garantir que seja tratado como UTC
  const dataUtc = dataString.endsWith("Z") ? dataString : dataString + "Z";
  const data = new Date(dataUtc);

  const opcoes = {
    timeZone: "America/Sao_Paulo",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  };

  if (incluirHora) {
    opcoes.hour = "2-digit";
    opcoes.minute = "2-digit";
  }

  return data.toLocaleString("pt-BR", opcoes);
};

/**
 * Formata apenas a data (sem hora)
 */
export const formatarData = (dataString) => {
  return formatarDataUtc(dataString, false);
};

/**
 * Formata data e hora
 */
export const formatarDataHora = (dataString) => {
  return formatarDataUtc(dataString, true);
};